// @flow

import React, { type Node } from 'react';
import { ErrorDisplay } from '../../../commons/molecules';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

export function Retry(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch(country){
    case 'br':
      return <PortugueseErrorMessage/>;

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'py':
    case 'uy':
      return <SpanishErrorMessage/>;

    case 'za':
    case 'ke':
    case 'ng':
      return <EnglishErrorMessage/>;

    default:
      throw new Error(`No message found for greeting message in country ${country}`);
  }
}

function PortugueseErrorMessage(): Node {
  return(
    <div data-test-id="retry-message">
      <ErrorDisplay>
        <p>Seu pagamento não foi aprovado.</p>
        <p>Revise seus dados ou escolha outro método de pagamento.</p>
      </ErrorDisplay>
    </div>
  );
}

function SpanishErrorMessage(): Node {
  return(
    <div data-test-id="retry-message">
      <ErrorDisplay>
        <p>Su pago no fue aprobado.</p>
        <p>Revise sus datos o elija otro método de pago.</p>
      </ErrorDisplay>
    </div>
  );
}

function EnglishErrorMessage(): Node {
  return(
    <div data-test-id="retry-message">
      <ErrorDisplay>
        <p>Your payment has not been approved</p>
        <p>Please review your details or choose another payment method</p>
      </ErrorDisplay>
    </div>
  );
}
